import {useEffect, useState} from "react";
import {useLocation, useNavigate,useParams } from "react-router-dom";


import {useDispatch} from "react-redux";
import MainLayout from "../../../commons/layout/MainLayout/index";

import HeaderHs2 from "../../../commons/components/Header/headerHs2";

import ROUTERS from "../../../commons/constans/router";
import InfiniteScroll from 'react-infinite-scroll-component';
import API, {ROUTES} from "../../../commons/api/api";
import _styles from "./_styles.scss"
import moment from "moment";
import SkeletonLoadingComponent from "../../../commons/components/SkeletonLoading";

const RenderImageDetail = ({images}) => {
    let image_render = '';
    if(images && images.length > 0){
        images.map((value,key)=>{
            image_render += `<img src=${value.url} />`
        })
    }
    return <div className="attachments" dangerouslySetInnerHTML={{__html: image_render}} />
}

const NotificationDetailPageComponent = (props) => {
    const navigate = useNavigate();
    const [detailNofitication, setDetailNofitication] = useState({});
    const params = useParams();
    var id = params?.id ? params?.id : ''

    const location = useLocation();
    const backMenuHome = () => {
        navigate(ROUTERS.NOTIFICATION, {
            state: location.state
        })
    }

    useEffect(() => {
        setDetailNofitication(props?.dataDetail)
    }, [props]);

const loadingDiv = <div className="wrapper">
        <section className="lists">
            <div className="lists__item last">
                <div className="lists__item__content w-100 loading-content">
                    <span><SkeletonLoadingComponent circle={false} width="30%" height="14px"/></span>
                    <h3><SkeletonLoadingComponent circle={false} width="100%" height="14px"/></h3>
                </div>
            </div>
        </section>
        <div className="container">
            <p className="content mb-0">
                <SkeletonLoadingComponent circle={false} width="100%" height="14px"/>
                <SkeletonLoadingComponent circle={false} width="100%" height="14px"/>
                <SkeletonLoadingComponent circle={false} width="100%" height="14px"/>
                <SkeletonLoadingComponent circle={false} width="100%" height="14px"/>
                <SkeletonLoadingComponent circle={false} width="100%" height="14px"/>
            </p>
        </div>
        <div className={'back-list-bottom-page'}>
            <button type="button" className="btn btn-block btn-primary" onClick={()=>backMenuHome()}>목록</button>
        </div>
    </div>

    const convertToBr = (content) => {
        return content.replace(/\r\n|\r|\n/g, '<br />')
    }

    return (
        <MainLayout pageID={"notification-detail"} displayBottomNav={false} >
            <HeaderHs2
                title={"공지사항"}
                labelLeft={true}
                labelRight={false}
                handleLabelLeft={backMenuHome}
            />
            {props?.loading ? (loadingDiv) : (id != '' ? (<div className="wrapper">
                <section className="lists">
                    <div className="lists__item last">
                        <div className="lists__item__content">
                            <span>{moment(detailNofitication?.start_date).format('Y-MM-DD')}</span>
                            <h3>{detailNofitication?.title}</h3>
                        </div>
                    </div>
                </section>
                <div className="container">
                    <p className="content" dangerouslySetInnerHTML={{ __html: convertToBr(detailNofitication?.content) }}></p>
                    {/* <RenderImageDetail images={detailNofitication?.attachment_url || ''} /> */}
                    {
                        detailNofitication?.attachment_url?.url && 
                        <div className="box-img">
                            <img className="img" src={detailNofitication?.attachment_url?.url || ''} alt="" />
                        </div>
                    }
                    
                    {/*<div className="attachments">*/}
                    {/*    {detailNofitication?.attachment ? (<img src={detailNofitication?.attachment} />) : ''}*/}
                    {/*</div>*/}
                </div>
                <div className={'back-list-bottom-page'}>
                    <button type="button" className="btn btn-block btn-primary" onClick={()=>backMenuHome()}>목록</button>
                </div>


            </div>) : '')}

        </MainLayout>
    );
};

export default NotificationDetailPageComponent;
